
import { useState, useRef } from 'react';

export const useSpeechProgress = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [progress, setProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  
  const progressIntervalRef = useRef<number | null>(null);
  const textLengthRef = useRef<number>(0);
  const startTimeRef = useRef<number>(0);
  const speechCheckTimeoutRef = useRef<number | null>(null);
  
  const clearProgressTracking = () => {
    if (progressIntervalRef.current) {
      clearInterval(progressIntervalRef.current);
      progressIntervalRef.current = null;
    }
    
    if (speechCheckTimeoutRef.current) {
      clearTimeout(speechCheckTimeoutRef.current);
      speechCheckTimeoutRef.current = null;
    }
  };
  
  const startProgressTracking = (rate: number, speechSynthRef: React.MutableRefObject<SpeechSynthesis | null>) => {
    clearProgressTracking();
    
    progressIntervalRef.current = window.setInterval(() => {
      const elapsedTime = Date.now() - startTimeRef.current;
      // Adjust duration estimate based on rate (faster rate = shorter duration)
      const durationEstimate = (textLengthRef.current * 60) / rate; 
      const calculatedProgress = Math.min((elapsedTime / durationEstimate) * 100, 100);
      setProgress(calculatedProgress);
      
      if (!speechSynthRef.current?.speaking && calculatedProgress >= 99) {
        setIsPlaying(false);
        setProgress(100);
        clearProgressTracking();
      }
    }, 100);
    
    return () => clearProgressTracking();
  };
  
  return {
    isPlaying,
    setIsPlaying,
    isPaused,
    setIsPaused,
    progress,
    setProgress,
    isLoading,
    setIsLoading,
    hasError,
    setHasError,
    progressIntervalRef,
    textLengthRef,
    startTimeRef,
    speechCheckTimeoutRef,
    startProgressTracking,
    clearProgressTracking,
  };
};

export default useSpeechProgress;
